import { jsx as t } from "react/jsx-runtime";
import { useMemo as e } from "react";
import o from "../../../assets/AddIcon.svg.js";
import i from "../../../assets/EditIcon.svg.js";
import { DialogTitleBasic as r } from "./DialogTitleBasic.js";
import { DialogType as s } from "./types.js";
const a = { [s.Create]: "Створення", [s.Edit]: "Редагування" }, c = ({ type: c2 = s.Create, title: m, subtitle: n, copy: p, showSubtitle: d = false, loading: l = false, createIcon: f = t(o, {}), editIcon: u = t(i, {}), icon: g }) => {
  const j = e(() => ({ [s.Create]: f, [s.Preview]: g, [s.Edit]: u }), [f, u, g]), v = c2 === s.Preview || d ? n : a[c2];
  return t(r, { icon: g ?? j[c2], title: m, subtitle: v, copy: c2 !== s.Create ? p : void 0, loading: l });
};
export {
  c as DialogTitle,
  c as default
};
//# sourceMappingURL=DialogTitle.js.map
